import React from 'react';
import {marginBottom, marginTop} from "../../common/script";
import {Col, Row} from "antd";


export default class OurBusinessPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemList: [{
                img: 'https://qiniu.mrcargo.com/zs_business_air.png',
                firstTitle: 'Air',
                lastTitle: 'Freight',
                info: 'The company undertakes the import and export business of air transport, including general cargo, express mail, various dangerous goods and frozen goods, and provides a point-to-point one-stop service by using the overseas agency network to make the transportation process transparent and visualized.'
            }, {
                img: 'https://qiniu.mrcargo.com/zs_business_sea.png',
                firstTitle: 'Sea',
                lastTitle: 'Freight',
                info: 'For bulk cargo, we provide convenient ocean import and export services, customized transportation solutions, charter or bulk carriers, etc.'
            }, {
                img: 'https://qiniu.mrcargo.com/zs_business_road.png',
                firstTitle: 'Road',
                lastTitle: 'Freight',
                info: 'The advantages of inland transportation network at home and abroad make it no longer difficult to pick up and deliver goods overseas. The company also provides diversified transportation services such as various supervised trucks and cold chain trucks.'
            }],
        }
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs_business_banner.png'} alt={'zs_business_banner'}
                         className={'width100p'}/>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>Our Business</span>
                    </div>
                </div>
                <Row justify={'center'} className={'bg-grep-gradient'}>
                    <Col span={12} style={Object.assign(marginTop(8), marginBottom(8))}>
                        <div >
                            <span className={'quotes-view'} style={{color:'#fff'}}>"</span>
                            <span className={'font-size18 colorfff '} style={marginTop(2)}>International Freight
                                Dedicated Storage Platform, Big
                                Data and Logistics Network Upgrade Traditional Inefficient Mode, Intelligent Management
                                Match
                                Bottom Level Upgrade of Intelligent Space.
                            </span>
                            <span className={'quotes-view'} style={{color:'#fff'}}>"</span>
                        </div>
                    </Col>
                </Row>
                {
                    this.state.itemList.map((item, index) => {
                        return this.itemView(item, index)
                    })
                }
            </div>
        );
    }

    itemView(item, index) {
        return <div key={index} className={'flex-col justify-center'} style={{background: index % 2 === 1 ? '#F5F7FA' : '#fff'}}>
            <div className={'width100p'} style={Object.assign({position: 'relative'}, marginTop(12))}>
                <div className={'text-center'} style={this.itemIndexView(index)}>0{index + 1}</div>
                <div className={'font-size40 business-item-title colorDefault flex-row justify-center font-italic'}
                     style={{lineHeight: '54px'}}>
                    <div className={`${index % 2 === 1?'bg-f5f7fa':'bg-fff'}`}>{item.firstTitle}</div>
                    <div className={`${index % 2 === 1?'bg-f5f7fa':'bg-fff'}`} style={{paddingLeft: '8px'}}>{item.lastTitle}</div>
                </div>
            </div>
            <div style={Object.assign(marginTop(9), marginBottom(12))}
                 className={`width100p flex-row justify-center ${index % 2 === 1 ? 'flex-row-reverse' : ''}`}>
                <img src={item.img} alt={item.img}/>
                <div className={'business-item-info flex-row justify-center'}>
                    <div>{item.info}</div>
                </div>
            </div>
        </div>
    }


    itemIndexView(index) {
        return {
            fontSize: '140px',
            opacity: index % 2 === 1 ? 1 : 0.05,
            color: index % 2 === 1 ? '#ffffff' : '#1e170b',
            lineHeight: '18px',
            fontWeight: 400,
        }
    }
}









